import React, { useEffect, useState } from "react"
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Alert
} from "reactstrap"
import DataTable from "react-data-table-component"
import MetaTags from "react-meta-tags"
import axios from "axios"
// plastics auth service
import PlasticsApplication from "../../services/PlasticsApplication.service"
import General from "services/GeneralEndpoints"

const user = JSON.parse(localStorage.getItem("authUser"))

const plasticsApp = new PlasticsApplication(user)
let generalService = new General(user)

function PlasticsRecycled() {
  const [companies, setcompanies] = useState([])
  const [data, setData] = useState([])
  const [newEntry, setNewEntry] = useState({
    company_id: "",
    report_month: "",
    quantity: 0,
  })
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)
  const [disableBtn, setdisableBtn] = useState(false)

  const columns = [
    {
      name: "Date",
      selector: "date",
      sortable: true,
    },
    {
      name: "Quantity (kg)",
      selector: "quantity",
      sortable: true,
    },
  ]

  useEffect(() => {
    loadData();
    fetchCompanies()
  }, [])

  const fetchCompanies = () => {
    generalService.getCompanies().then(response => {
      if (response.status) {
        const comps = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setcompanies(comps)
      }
    })
  }

  const loadData = () => {
    // get reported recycled quantities
   
  }

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  const handleCompanyChange = (company) => {
    setNewEntry({...newEntry, company_id: company})
  }

  const handleInputChange = e => {
    const { name, value } = e.target
    setNewEntry({
      ...newEntry,
      [name]: name === "quantity" ? parseFloat(value) : value,
    })
  }

  const addEntry = async() => {
    setdisableBtn(true)
    
    // Report month will be the first day of each month
    const data = {...newEntry, company_id: parseInt(newEntry.company_id, 10), report_month: newEntry.report_month + "-01"}
    
    console.log("data  ", data)
    const response = await generalService.addRecycledQuantity(data)
    console.log("response ---> ", response)
    if (response.status) {
        loadData()
        setNewEntry({
            company_id: "",
            date: "",
            quantity: 0,
          })
        toggleModal()
        setShowSuccessAlert(true)
        setdisableBtn(false)
    } else {
        setShowSuccessAlert(false)
        setdisableBtn(false)
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Recycled | REMA</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            {showSuccessAlert ? (
              <Alert color="success">
              Entry added successfully!
              <button
                type="button"
                className="close"
                onClick={() => setShowSuccessAlert(false)}
              >
                &times;
              </button>
            </Alert>
            ) : null}
            <Row className="align-items-center">
              <Col md={8}>
                <h6 className="page-title">Recycled</h6>
              </Col>
              <Col md={4}></Col>
            </Row>
            <br></br>

            <Button color="primary" onClick={toggleModal}>
              Add Entry
            </Button>

            <Modal isOpen={isModalOpen} toggle={toggleModal}>
              <ModalHeader toggle={toggleModal}>Add Entry</ModalHeader>
              <ModalBody>
                <Form>
                  <FormGroup>
                    <Label for="company">Company</Label>
                    <Input
                      type="select"
                      name="company"
                      id="company"
                      value={newEntry.company_id}
                      onChange={e => handleCompanyChange(e.target.value)}
                    >
                      <option value="">Select a company</option>
                      {companies}
                    </Input>
                  </FormGroup>
                  <FormGroup>
                    <Label for="date">Date</Label>
                    <Input
                      type="month"
                      name="report_month"
                      id="date"
                      value={newEntry.date}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="quantity">Quantity Recycled(kg)</Label>
                    <Input
                      type="number"
                      name="quantity"
                      id="quantity"
                      value={newEntry.quantity}
                      onChange={handleInputChange}
                    />
                  </FormGroup>
                </Form>
              </ModalBody>
              <ModalFooter>
                <Button disabled={disableBtn} color="primary" onClick={addEntry}>
                  Add Entry
                </Button>
                <Button color="secondary" onClick={toggleModal}>
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>

            <DataTable
              title="Recycling Data"
              columns={columns}
              data={data}
              pagination
              highlightOnHover
              selectableRows
              selectableRowsHighlight
              paginationRowsPerPageOptions={[10, 25, 50, 100]}
            />
          </div>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default PlasticsRecycled
